var __WEBPACK_NAMESPACE_OBJECT__ = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "page-editor-ui": "static-1.39570",
      "ably": "static-3.62",
      "apollo-dlb": "static-3.98",
      "client-types": "static-1.510",
      "codemirror-dlb": "static-1.59751",
      "collaboration-sidebar": "static-1.59013",
      "ContentComponents": "static-2.72382",
      "ContentData": "static-1.69501",
      "ContentEditorUI": "static-2.78192",
      "ContentUtils": "static-1.69426",
      "customer-agent-datasources-lib": "static-1.8089",
      "customer-agent-discovery-components-lib": "static-1.4228",
      "customer-agent-forms": "static-1.5602",
      "data-fetching-client": "static-1.10095",
      "editor-components": "static-1.13856",
      "emoji-mart": "static-3.6",
      "FileManagerLib": "static-1.40439",
      "foundations-assets": "static-1.5341",
      "foundations-components": "static-1.8710",
      "head-dlb": "static-1.5007",
      "hs-test-utils": "static-1.8492",
      "hub-http": "static-1.6664",
      "hub-http-shared-msw-handlers": "static-1.10865",
      "hubspot-dlb": "static-2.1911",
      "hubspot-prosemirror": "static-1.19244",
      "HubStyleTokens": "static-2.11947",
      "I18n": "static-7.1703",
      "InpageEditorUI": "static-1.86632",
      "jasmine-immutable": "static-1.3398",
      "jasmine-runner": "static-1.6906",
      "layout-dnd-utils": "static-1.12164",
      "page-creation-lib": "static-1.2127",
      "personalization-lib": "static-1.8349",
      "quartz": "static-1.7634",
      "react-dlb": "static-1.93",
      "react-dnd": "static-4.51",
      "react-dnd-html5-backend": "static-4.5",
      "react-redux": "static-7.80",
      "react-transition-group": "static-2.77",
      "react-utils": "static-2.5647",
      "redux-thunk": "static-2.84",
      "reselect": "static-3.16",
      "settings-ui-lib": "static-1.12985",
      "sinon": "static-1.9",
      "tinymce": "static-6.5",
      "ui-addon-draggable": "static-1.4397",
      "ui-components-test-utils": "static-1.6084",
      "ui-images": "static-2.1274",
      "ui-memberships-settings-lib": "static-1.35138",
      "video-components-external": "static-1.12392",
      "webpack-env": "static-1.54",
      "amplitude-session-replay-browser": "static-1.60",
      "atom": "static-1.5531",
      "blueimp-md5": "static-1.8",
      "copilot-plugins": "static-1.12079",
      "cropperjs": "static-1.10",
      "customer-data-objects-ui-components": "static-1.13485",
      "customer-data-ui-utilities": "static-1.10288",
      "data-token-views": "static-1.17077",
      "feedback-loader": "static-1.30026",
      "fuzzy": "static-1.8",
      "hs-promise-utils": "static-1.6048",
      "hub-http-contrib": "static-1.3486",
      "HubStyle": "static-2.12254",
      "icons": "static-2.700",
      "InboxConnectUtils": "static-4.15807",
      "integrations-lib": "static-1.17381",
      "interframe": "static-3.5197",
      "laboratory-lib": "static-3.7604",
      "nav-meta": "static-1.30757",
      "onboarding-scopes": "static-1.6907",
      "outpost": "static-1.4587",
      "PatternValidationJS": "static-1.3342",
      "pictos": "static-7.195",
      "property-translator": "static-1.5834",
      "react-beautiful-dnd": "static-1.74",
      "react-immutable-proptypes": "static-2.8",
      "react-input-autosize": "static-2.17",
      "react-select-plus": "static-1.117",
      "react-tinymce": "static-1.56231",
      "react-virtualized": "static-2.111",
      "reference-resolvers": "static-1.8635",
      "sanitize": "static-1.4930",
      "sanitize-text": "static-1.8613",
      "seamless-immutable": "static-7.6",
      "SharedI18nStrings": "static-1.187",
      "simple-menus-core": "static-1.15778",
      "StyleGuideUI": "static-3.517",
      "superstore": "static-1.5214",
      "tinymce-config": "static-2.55357",
      "tinymce-data": "static-1.41442",
      "transmute": "static-2.97",
      "ui-addon-sales-email": "static-1.5658",
      "urlinator": "static-1.4971",
      "usage-tracker-core": "static-1.7627",
      "video-embed": "static-1.36884",
      "web-interactives-components": "static-1.14454",
      "web-interactives-data": "static-1.14455",
      "wootric-nps": "static-1.7288",
      "ai-components-ui-library": "static-1.9979",
      "apollo-stack-hubspot": "static-3.94",
      "asset-actions-lib": "static-1.47222",
      "campaigns-lib": "static-1.27875",
      "content-assistance-lib": "static-1.8392",
      "content-label-lib": "static-1.7268",
      "content-management-actions-lib": "static-1.28652",
      "content-management-data-lib": "static-1.6196",
      "content-management-restrictions-lib": "static-1.5998",
      "copilot-toolkit": "static-1.12107",
      "cssUtils": "static-1.1078",
      "cta-picker": "static-1.37189",
      "customer-data-objects": "static-1.8151",
      "customer-data-properties": "static-1.52983",
      "customer-data-property-utils": "static-1.8503",
      "customer-data-reference-ui-components": "static-1.13622",
      "data-token-picker": "static-1.17096",
      "error-messaging-js": "static-1.5592",
      "file-manager-components": "static-1.24799",
      "FileManagerCore": "static-1.40298",
      "FormsCommonComponents": "static-1.86798",
      "foundations-theming": "static-1.4943",
      "growth-onboarding-beacon": "static-1.6043",
      "growth-onboarding-confetti": "static-1.3516",
      "growth-onboarding-next-action-components": "static-1.2974",
      "growth-payments-core": "static-1.26463",
      "hs-lodash": "static-4.45",
      "hubspot-url-utils": "static-1.4383",
      "immer": "static-1.105",
      "immutable": "static-2.88",
      "layout-data-lib": "static-1.10489",
      "media-bridge-lib": "static-1.19609",
      "object-builder-ui-client": "static-1.49995",
      "onboarding-tours": "static-1.17366",
      "onboarding-tours-client": "static-1.5581",
      "page-lib": "static-1.23637",
      "payment-link-components": "static-1.24402",
      "payments-post-enroll-local-storage-lib": "static-1.5559",
      "PortalIdParser": "static-2.404",
      "products-ui-components": "static-1.41368",
      "quartz-routing": "static-1.1064",
      "quick-fetch": "static-1.4222",
      "raven": "static-3.5925",
      "react": "static-7.202",
      "react-colorpicker": "static-2.10666",
      "react-dnd-compat": "static-1.5066",
      "react-rhumb": "static-1.17191",
      "redux": "static-4.81",
      "redux-request-state": "static-1.11095",
      "reference-resolvers-lite": "static-1.8563",
      "rich-text-lib": "static-1.20519",
      "rpc-client-utils": "static-1.5128",
      "SharedLegalStrings": "static-1.2184",
      "simple-menus-lib": "static-1.17295",
      "smart-content-lib": "static-1.44074",
      "styled-components": "static-2.100",
      "theme-previewer-lib": "static-1.54102",
      "tinymce-copilot": "static-1.17425",
      "tinymce-plugins": "static-1.58471",
      "tinymce-themes": "static-1.57327",
      "ui-addon-emoji-picker": "static-1.10319",
      "ui-addon-form-validation": "static-1.11343",
      "ui-addon-i18n": "static-1.11601",
      "ui-addon-iframeable": "static-1.9531",
      "ui-addon-opt": "static-4.8846",
      "ui-addon-upgrades": "static-9.18537",
      "ui-business-units-lib": "static-1.9553",
      "ui-gdpr-components": "static-1.10652",
      "ui-product-approvals": "static-1.29632",
      "ui-product-approvals-common": "static-1.1527",
      "ui-shepherd-react": "static-3.10732",
      "ui-suspension-banners-lib": "static-1.6845",
      "UIComponents": "static-3.8893",
      "underscore": "static-1.8",
      "usage-tracker": "static-1.7777",
      "usage-tracker-session-replay": "static-1.5463",
      "user-context": "static-1.5508",
      "xray-recommendation-lib": "static-1.8432",
      "codemirror": "static-5.106",
      "react-codemirror": "static-1.11095",
      "enviro": "static-4.455",
      "hs-promise-rejection-tracking": "static-1.5587",
      "raven-hubspot": "static-1.6232",
      "classnames": "static-2.10",
      "hoist-non-react-statics": "static-3.9",
      "metrics-js": "static-1.9990",
      "moment": "static-3.75",
      "react-dom": "static-7.85",
      "bend-plugin-quartz-routing": "static-1.712",
      "chatspot-widget-iframe": "static-1.23727",
      "collaboration-sidebar-common": "static-1.3810",
      "frontend-preferences-client": "static-1.8374",
      "hs-resources": "static-1.647",
      "magpie-lib": "static-1.5893",
      "marketing-platform-lib": "static-1.7353",
      "pulse": "static-1.1098",
      "quartz-config": "static-1.1412",
      "quartz-core": "static-1.6853",
      "advanced-menus-core": "static-1.15779",
      "advanced-menus-lib": "static-1.12541",
      "automation-ui-ubb": "static-1.6775",
      "avatar-components": "static-1.2941",
      "cms-field-types": "static-1.5268",
      "content-embed-lib": "static-1.7796",
      "ExportDialog": "static-6.10826",
      "forms-utils-lib": "static-1.13302",
      "foundations-components-legacy": "static-1.1735",
      "integrations-error-boundary-lib": "static-1.14796",
      "messaging-usage-based-billing-components-lib": "static-1.2283",
      "payments-embed-points-lib": "static-1.13814",
      "products-iframe-lib": "static-1.8862",
      "ui-addon-draggable-compat": "static-2.4719",
      "ui-brand-identity-lib": "static-1.16901",
      "usage-based-billing-components-lib": "static-1.10704",
      "usage-tracker-container": "static-1.7767",
      "video-data-lib": "static-1.36050",
      "videoconference-integration-components": "static-1.7498",
      "graphql": "static-1.93",
      "access-check-ui-lib": "static-1.1847",
      "editor-iframe-lib": "static-1.8979",
      "FireAlarmUi": "static-1.4841",
      "hub-http-janus": "static-1.904",
      "hubspot-apollo-client": "static-1.5335",
      "layout-dnd-components": "static-1.13189",
      "marketing-email-service-types": "static-1.2209",
      "quartz-auth": "static-1.1309",
      "smart-content-core": "static-1.43421",
      "social-composer-lib": "static-1.60558",
      "structured-content-lib": "static-1.26158",
      "timezone-utils": "static-2.5687",
      "ui-addon-video-player": "static-1.9079",
      "ui-asset-management-lib": "static-1.11557",
      "ui-tool-access": "static-1.10614",
      "content-icons-ui": "static-1.2439",
      "conversations-skeleton-state": "static-1.7604",
      "customer-agent-audience-seg-components-lib": "static-1.914",
      "customer-agent-knowledge-generator-lib": "static-1.360",
      "customer-agent-short-answers-lib": "static-1.1179",
      "prosemirror": "static-1.13",
      "breeze-engine-core": "static-1.1363",
      "breeze-engine-lib": "static-1.2085",
      "final-form": "static-1.82",
      "foundations-theming-specialty": "static-1.2659",
      "voice-agents-components": "static-1.4035",
      "fast-json-stable-stringify": "static-1.4",
      "react-aria": "static-1.76",
      "audio-components": "static-1.6538",
      "FileManagerImages": "static-1.37950",
      "quartz-i18n": "static-1.1309",
      "video-components": "static-1.14394",
      "bend-plugin-foundations-components": "static-1.4979",
      "floating-ui": "static-1.67",
      "framer-motion": "static-1.83",
      "hs-story-utils": "static-1.9879",
      "react-create-root-preference": "static-1.99",
      "tanstack-table": "static-1.65",
      "trellis-assets": "static-1.3033",
      "ui-fonts": "static-1.1209",
      "HeadJS": "static-2.817",
      "hs-test-utils-bend-plugin": "static-1.3603",
      "msw": "static-1.102",
      "msw-config": "static-1.26",
      "testing-library": "static-1.163",
      "hs-locale-management": "static-1.391",
      "ts-schema": "static-1.4385",
      "content-media-capture": "static-1.5748",
      "knowledge-content-types": "static-1.8743",
      "i18n-data": "static-1.234",
      "moment-timezone": "static-5.95",
      "jquery": "static-3.6",
      "NamespacedHubStyle": "static-2.9359",
      "react-dnd-ipeui-backend": "static-1.2345",
      "jasmine": "static-4.4763",
      "customer-data-filters-ui": "static-1.41311",
      "marketplace-embed": "static-1.23163",
      "ui-addon-react-router-dom": "static-1.9984",
      "flux-actions": "static-1.380",
      "redux-observable": "static-1.79",
      "ReduxMessenger": "static-2.10824",
      "rxjs": "static-5.10",
      "react-flip-move": "static-1.82",
      "foundations-components-test-utils": "static-1.6193",
      "apollo-link-hub-http": "static-2.5042",
      "content-media-composition-data-lib": "static-1.13552",
      "content-media-compositions": "static-2.17559",
      "idb-keyval": "static-1.55",
      "immerable": "static-1.4598",
      "magpie-types": "static-1.5353",
      "ai-rendering-library": "static-1.11363",
      "chatspot-core": "static-1.23736",
      "simple-logging-lib": "static-1.3508",
      "react-immutable-render-mixin": "static-1.9",
      "nudge-client-utils": "static-1.3382",
      "sassPrefix": "static-1.344",
      "salesImages": "static-1.710",
      "integrations-tracking-lib": "static-1.6072",
      "native-integrations-shared-strings": "static-1.8219",
      "ui-universal-auth": "static-1.9684",
      "autolinker": "static-3.11",
      "chirp-fetch": "static-1.2359",
      "foundations-theming-base": "static-1.3928",
      "campaigns-utils-lib": "static-1.3694",
      "attribution-lib": "static-1.42979",
      "crm-message-bus": "static-1.44053",
      "crm-pipelines-api-client-types": "static-1.4434",
      "framework-listing-lib": "static-2.29764",
      "nudge-custom-ui-functions": "static-1.1711",
      "reporting-enablement": "static-1.24128",
      "reporting-ui-components": "static-2.66552",
      "stylex": "static-1.46",
      "trellis-components": "static-1.3052",
      "trellis-theming": "static-1.1448",
      "ui-addon-teams": "static-1.21993",
      "ui-coaching-tips": "static-1.29561",
      "hubspotter-http": "static-1.4965",
      "inbound-db-properties-service-client": "static-1.4141",
      "batch-promise": "static-1.2002",
      "calling-global-api": "static-1.66119",
      "calling-internal-common": "static-1.31780",
      "calling-lifecycle-internal": "static-1.67501",
      "calling-lifecycle-messages": "static-1.59794",
      "commerce-products-lib": "static-1.10850",
      "conditional-properties-service-client": "static-1.4103",
      "crm-index-visualization-core": "static-1.4730",
      "crm-links": "static-1.6762",
      "customer-data-properties-shared-msw-handlers": "static-1.10192",
      "external-options-client-types": "static-1.4431",
      "formula-editor": "static-1.14982",
      "framework-data-schema-resolvers": "static-1.7350",
      "google-libphonenumber": "static-1.49",
      "inbound-db-meta-service-client": "static-1.3768",
      "inbounddb-objects-service-types": "static-1.4513",
      "meetings-icalendar-utils-lib": "static-1.1092",
      "multi-currency-client-types": "static-1.3998",
      "pipeline-validation-client-types": "static-1.4272",
      "property-value-citations": "static-1.3597",
      "smart-data-capture-core": "static-1.435",
      "smart-property-lib": "static-1.8592",
      "tiered-pricing": "static-1.2195",
      "topics-actions-lib": "static-1.634",
      "trellis-ext-i18n": "static-1.1352",
      "trial-components-library": "static-1.14342",
      "zustand": "static-1.88",
      "poll-commands": "static-1.3930",
      "breeze-artifacts-sdk": "static-1.848",
      "html-to-image": "static-1.65",
      "redux-toolkit": "static-1.82",
      "forms-ai-lib": "static-1.4952",
      "bend-plugin-foundations-theming": "static-1.3426",
      "embedded-academy-lib": "static-1.15956",
      "growth-onboarding-feedback-components": "static-1.7037",
      "seat-types-lib": "static-1.1009",
      "purchase-motions-components": "static-1.6605",
      "getting-started-shared-tasks": "static-1.19524",
      "growth-data-modal": "static-1.6103",
      "growth-onboarding-next-action-utils": "static-1.2946",
      "navigation-components": "static-1.19120",
      "onboarding-tours-utils": "static-1.1433",
      "ui-shepherd-tracker": "static-1.8113",
      "commerce-tours-lib": "static-1.6829",
      "growth-onboarding-reliability": "static-1.5536",
      "sales-checkout-service-client": "static-1.3979",
      "commerce-permissions": "static-1.1240",
      "commerce-subscription-lib": "static-1.38037",
      "commerce-tax-lib": "static-1.993",
      "crm_data": "static-4.93159",
      "customer-data-tracking": "static-1.7328",
      "dispatcher": "static-1.147",
      "framework-data-table": "static-2.12803",
      "price-books-api": "static-1.2013",
      "price-books-components": "static-1.2071",
      "property-description-translator": "static-1.4274",
      "ramp-editor": "static-1.1129",
      "quartz-head": "static-1.1299",
      "quartz-test": "static-1.1309",
      "csstype": "static-1.50",
      "beacon-keepalive-queue": "static-1.155",
      "web-vitals": "static-1.19",
      "bend-plugin-chirp-manifest": "static-1.538",
      "commerce-tools-ui-lib": "static-1.11283",
      "redux-mock-store": "static-1.8",
      "redux-undo": "static-1.10",
      "navigation-messaging": "static-1.8447",
      "merchandise-lib": "static-1.283",
      "trellis-ext-dnd": "static-1.508",
      "getting-started-shared-tasks-store": "static-1.18642",
      "seo-tools-lib": "static-1.6901",
      "diff-match-patch": "static-1.7",
      "browser-eslint": "static-2.57",
      "bender-build-tools": "static-1.3553",
      "event-emitter": "static-1.1417",
      "fdsr-migration-layer": "static-1.469",
      "framework-builder-read-service-client": "static-1.4323",
      "reactive-lib": "static-1.1179",
      "bend-plugin-pulse": "static-1.601",
      "fast-json-patch": "static-1.74",
      "opentelemetry-fe-types": "static-1.245",
      "general-store": "static-6.20",
      "mobile-manifest-mixins": "static-1.601",
      "module-federation": "static-1.37",
      "opentelemetry-fe": "static-1.620",
      "quartz-tracking": "static-1.1013",
      "automation-platform-service-types": "static-1.2726",
      "automation-ui-core": "static-2.22795",
      "automation-ui-types": "static-1.20859",
      "automation-ui-usage-tracking": "static-1.22258",
      "data-studio-ubb": "static-1.3774",
      "trellis-migration-context": "static-1.33",
      "messaging-shared-utils-lib": "static-1.1732",
      "messaging-user-info-utils-lib": "static-1.1902",
      "commerce-analytics-service-client": "static-1.3967",
      "payments-enrollment-embed-lib": "static-1.24154",
      "fail-safe": "static-1.403",
      "highcharts": "static-8.115",
      "one-click-checkout": "static-1.718",
      "platform-infra-nav-components": "static-1.7993",
      "reporting-visualizations": "static-1.61357",
      "subscription-experience-data-types": "static-1.15410",
      "permissions-shared-i18n-strings-fe": "static-1.2143",
      "hubspot-apollo-cache": "static-1.794",
      "hubspotter-http-shared-msw-handlers": "static-1.10863",
      "nested-table": "static-1.688",
      "breeze-engine-chat-components": "static-1.1063",
      "highlight.js": "static-1.90",
      "markdown-it": "static-1.6",
      "calling-orchestration-shared-library": "static-1.36945",
      "social-insights-client-types": "static-1.22893",
      "stylex-utils": "static-1.170",
      "fix-webm-duration": "static-1.34",
      "notification-sounds": "static-1.4881",
      "customer-data-filters-ui-msw-helpers": "static-1.23746",
      "events-data-lib": "static-1.702",
      "FormUrlGenerator": "static-2.5170",
      "multi-account-reference-resolvers": "static-1.1461",
      "reporting-datasets-permissions-lib": "static-1.14730",
      "segments-client-types": "static-1.12089",
      "connections-embed-lib": "static-1.1710",
      "marketplace-ui-common": "static-1.21011",
      "marketplace-ui-install": "static-1.997",
      "marketplace-ui-tracking": "static-1.15181",
      "trellis-ecosystem": "static-1.7816",
      "js-cookie": "static-1.18",
      "breeze-onboarding-components": "static-1.1022",
      "data-integrations-breeze": "static-1.266",
      "global-styles-ai-lib": "static-1.453",
      "marketplace-embed-ba": "static-1.866",
      "mermaid": "static-1.44",
      "reporting-action-components": "static-1.42342",
      "reporting-data": "static-1.69283",
      "reporting-snowflake": "static-1.57899",
      "upgrade-components-lib": "static-1.696",
      "nudge-custom-function-registry": "static-1.3139",
      "nudge-renderer-utils": "static-1.3458",
      "whisper-core-api": "static-1.7600",
      "universal-page-editor-lib": "static-1.3464",
      "unified-auth-core-lib": "static-1.1480",
      "copilot-messaging": "static-1.2357",
      "report-customization-components": "static-1.14171",
      "restore-request-side-panel-lib": "static-1.1981",
      "customer-data-views-management": "static-1.26311",
      "framework-data-schema-quick-fetch": "static-1.7255",
      "switchboard-lib": "static-1.686",
      "data-quality-ui-library": "static-1.14234",
      "reporting-filters": "static-1.1254",
      "reporting-insights-lib": "static-1.2886",
      "reporting-plugins": "static-1.10951",
      "reporting-reports": "static-1.68959",
      "persist-promise": "static-1.4159",
      "base-ui": "static-1.27",
      "react-day-picker": "static-1.14",
      "tanstack-virtual": "static-1.42",
      "calling-error-reporting": "static-1.31787",
      "shared-worker-versioning": "static-1.11496",
      "calling-usage-tracker": "static-1.6989",
      "voice-sms-access-library": "static-1.2393",
      "products-ui-components-shared-msw-handlers": "static-1.11247",
      "crm-index-associations-lib": "static-1.6905",
      "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10948",
      "sales-views-client-types": "static-1.4712",
      "location-customization-utils-lib": "static-1.10378",
      "bark-lib": "static-1.16987",
      "browser-prettier": "static-1.11",
      "crm-properties-common-lib": "static-1.6346",
      "data-agent-kit": "static-1.875",
      "data-agent-test-utils": "static-1.419",
      "data-agent-utils": "static-1.888",
      "fsm": "static-1.4214",
      "policy-lib": "static-1.7264",
      "reference-resolvers-lite-shared-msw-handlers": "static-1.11011",
      "hubs-service-types": "static-1.1721",
      "purchase-motions-api": "static-1.6608",
      "signup-constants": "static-1.19902",
      "academy-common-lib": "static-1.15417",
      "signup-ui-url-generator": "static-2.8512",
      "onboarding-data-sync-lib": "static-1.2807",
      "user-context-client": "static-1.4965",
      "nest": "static-1.689",
      "commerce-billing-lib": "static-1.20476",
      "commerce-shared-components-lib": "static-1.19529",
      "crm_universal": "static-1.22690",
      "customer-data-email": "static-1.18612",
      "customer-data-associations": "static-1.7791",
      "tasks-actions-lib": "static-1.394",
      "line-items-api": "static-1.1296",
      "customer-data-rte": "static-1.33862",
      "cv-backend-services": "static-1.1607",
      "growth-onboarding-empty-states": "static-1.6497",
      "qrcode-generator": "static-1.80",
      "quotes-client-types": "static-1.39140",
      "dnd-kit": "static-1.20",
      "opentelemetry-web": "static-1.22",
      "immutable-less": "static-1.5107",
      "automation-ui-routing": "static-1.22216",
      "sql-reporting-client-types": "static-1.6014",
      "marketplace-ui-apps-core": "static-1.19543",
      "stripe-embedded-components": "static-1.8209",
      "bend-plugin-fail-safe": "static-1.354",
      "checkout-sdk": "static-3.24656",
      "payment-method-components": "static-1.7300",
      "touchless-buying-components": "static-1.6524",
      "upgrade-catalog-service-types": "static-1.3880",
      "edison-service-client-types": "static-1.849",
      "react-window": "static-1.13",
      "ts-utils-lib": "static-1.605",
      "calling-orchestration-schema": "static-1.37170",
      "integrations-reconnect-lib": "static-1.683",
      "unified-auth": "static-1.1198",
      "ai-settings-ui-library": "static-1.8550",
      "marketplace-ui-client-types": "static-1.18418",
      "ai-studio-lib": "static-1.12720",
      "ui-addon-integrations-directory-panel": "static-2.8409",
      "storybook-react": "static-1.44",
      "trellis-story-utils": "static-1.4956",
      "onboarding-journeys-lib": "static-1.1198",
      "dashboard-lib": "static-1.83251",
      "hubspot-prosemirror-plugins": "static-1.19236",
      "share-with-third-party-component-lib": "static-1.9166",
      "reporting-client-types": "static-1.2816",
      "crm-record-cards-service-types": "static-1.3863",
      "crm-export-dialog": "static-1.6731",
      "crm-index-ui-shimmer": "static-1.2936",
      "crm-view-components": "static-1.1456",
      "merge-modal-lib": "static-1.12991",
      "campaign-roi-lib": "static-1.10754",
      "ui-addon-calendars": "static-2.5818",
      "react-reducer-toolkit": "static-1.16629",
      "enrichment-settings-lib": "static-1.202",
      "academy-service-client": "static-1.4147",
      "croppie": "static-2.10",
      "SafeStorage": "static-1.4850",
      "meetings-connect-utils-lib": "static-1.8072",
      "utility-belt": "static-1.2992",
      "sequences-lib": "static-1.8736",
      "draft-content-plugins": "static-1.29118",
      "draft-convert": "static-2.83",
      "draft-extend": "static-3.87",
      "draft-js": "static-5.89",
      "draft-plugins": "static-2.22322",
      "developer-experience-shared-components": "static-1.10994",
      "ui-extensibility-client-types": "static-1.4371",
      "stripe-connect-js": "static-1.82",
      "hub-http-rxjs": "static-1.874",
      "normalizr": "static-3.9",
      "ramda": "static-1.7",
      "billing-payments-client-types": "static-1.4445",
      "company-details-components": "static-1.6659",
      "emoji-regex": "static-1.7",
      "react-performance-metrics-lib": "static-1.1008",
      "pricing-pages-ui-components": "static-1.16422",
      "quote-checkout-service-types": "static-1.3911",
      "adobe-sign-auth-lib": "static-1.726",
      "ads-unified-auth-lib": "static-1.1879",
      "custom-vendor-connection-lib": "static-1.248",
      "google-sheets-integration-lib": "static-1.1293",
      "microsoft-drive-auth-lib": "static-1.453",
      "slack-ui-library": "static-1.10855",
      "surveymonkey-integration-lib": "static-1.829",
      "simple-data-table": "static-1.3788",
      "property-management-iframe": "static-1.14412",
      "redux-actions": "static-3.74",
      "EmailSignatureEditor": "static-1.25209",
      "viral-links-lib": "static-1.7536",
      "sequences-client-types-lib": "static-1.8593",
      "apps-service-types": "static-1.4096",
      "oauth-service-types": "static-1.4597",
      "company-details-service-types": "static-1.4399",
      "segments-query-core": "static-1.1886",
      "pricing-pages-api": "static-1.16287",
      "property-management-common": "static-1.6700",
      "sales-email-signature-service-client": "static-1.4304",
      "crm-component-utils": "static-1.40134",
      "crm-actions": "static-1.6809",
      "crm-cards-sdk": "static-1.44951",
      "crm-fe-perf": "static-1.23352",
      "universal-record-utils-lib": "static-1.2314",
      "crm-object-search-query-utilities": "static-1.10418"
    },
    "depPathPrefixes": {
      "page-editor-ui": "/page-editor-ui/static-1.39570",
      "ably": "/ably/static-3.62",
      "apollo-dlb": "/apollo-dlb/static-3.98",
      "client-types": "/client-types/static-1.510",
      "codemirror-dlb": "/codemirror-dlb/static-1.59751",
      "collaboration-sidebar": "/collaboration-sidebar/static-1.59013",
      "ContentComponents": "/ContentComponents/static-2.72382",
      "ContentData": "/ContentData/static-1.69501",
      "ContentEditorUI": "/ContentEditorUI/static-2.78192",
      "ContentUtils": "/ContentUtils/static-1.69426",
      "customer-agent-datasources-lib": "/customer-agent-datasources-lib/static-1.8089",
      "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.4228",
      "customer-agent-forms": "/customer-agent-forms/static-1.5602",
      "data-fetching-client": "/data-fetching-client/static-1.10095",
      "editor-components": "/editor-components/static-1.13856",
      "emoji-mart": "/emoji-mart/static-3.6",
      "FileManagerLib": "/FileManagerLib/static-1.40439",
      "foundations-assets": "/foundations-assets/static-1.5341",
      "foundations-components": "/foundations-components/static-1.8710",
      "head-dlb": "/head-dlb/static-1.5007",
      "hs-test-utils": "/hs-test-utils/static-1.8492",
      "hub-http": "/hub-http/static-1.6664",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10865",
      "hubspot-dlb": "/hubspot-dlb/static-2.1911",
      "hubspot-prosemirror": "/hubspot-prosemirror/static-1.19244",
      "HubStyleTokens": "/HubStyleTokens/static-2.11947",
      "I18n": "/I18n/static-7.1703",
      "InpageEditorUI": "/InpageEditorUI/static-1.86632",
      "jasmine-immutable": "/jasmine-immutable/static-1.3398",
      "jasmine-runner": "/jasmine-runner/static-1.6906",
      "layout-dnd-utils": "/layout-dnd-utils/static-1.12164",
      "page-creation-lib": "/page-creation-lib/static-1.2127",
      "personalization-lib": "/personalization-lib/static-1.8349",
      "quartz": "/quartz/static-1.7634",
      "react-dlb": "/react-dlb/static-1.93",
      "react-dnd": "/react-dnd/static-4.51",
      "react-dnd-html5-backend": "/react-dnd-html5-backend/static-4.5",
      "react-redux": "/react-redux/static-7.80",
      "react-transition-group": "/react-transition-group/static-2.77",
      "react-utils": "/react-utils/static-2.5647",
      "redux-thunk": "/redux-thunk/static-2.84",
      "reselect": "/reselect/static-3.16",
      "settings-ui-lib": "/settings-ui-lib/static-1.12985",
      "sinon": "/sinon/static-1.9",
      "tinymce": "/tinymce/static-6.5",
      "ui-addon-draggable": "/ui-addon-draggable/static-1.4397",
      "ui-components-test-utils": "/ui-components-test-utils/static-1.6084",
      "ui-images": "/ui-images/static-2.1274",
      "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.35138",
      "video-components-external": "/video-components-external/static-1.12392",
      "webpack-env": "/webpack-env/static-1.54",
      "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
      "atom": "/atom/static-1.5531",
      "blueimp-md5": "/blueimp-md5/static-1.8",
      "copilot-plugins": "/copilot-plugins/static-1.12079",
      "cropperjs": "/cropperjs/static-1.10",
      "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13485",
      "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10288",
      "data-token-views": "/data-token-views/static-1.17077",
      "feedback-loader": "/feedback-loader/static-1.30026",
      "fuzzy": "/fuzzy/static-1.8",
      "hs-promise-utils": "/hs-promise-utils/static-1.6048",
      "hub-http-contrib": "/hub-http-contrib/static-1.3486",
      "HubStyle": "/HubStyle/static-2.12254",
      "icons": "/icons/static-2.700",
      "InboxConnectUtils": "/InboxConnectUtils/static-4.15807",
      "integrations-lib": "/integrations-lib/static-1.17381",
      "interframe": "/interframe/static-3.5197",
      "laboratory-lib": "/laboratory-lib/static-3.7604",
      "nav-meta": "/nav-meta/static-1.30757",
      "onboarding-scopes": "/onboarding-scopes/static-1.6907",
      "outpost": "/outpost/static-1.4587",
      "PatternValidationJS": "/PatternValidationJS/static-1.3342",
      "pictos": "/pictos/static-7.195",
      "property-translator": "/property-translator/static-1.5834",
      "react-beautiful-dnd": "/react-beautiful-dnd/static-1.74",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "react-select-plus": "/react-select-plus/static-1.117",
      "react-tinymce": "/react-tinymce/static-1.56231",
      "react-virtualized": "/react-virtualized/static-2.111",
      "reference-resolvers": "/reference-resolvers/static-1.8635",
      "sanitize": "/sanitize/static-1.4930",
      "sanitize-text": "/sanitize-text/static-1.8613",
      "seamless-immutable": "/seamless-immutable/static-7.6",
      "SharedI18nStrings": "/SharedI18nStrings/static-1.187",
      "simple-menus-core": "/simple-menus-core/static-1.15778",
      "StyleGuideUI": "/StyleGuideUI/static-3.517",
      "superstore": "/superstore/static-1.5214",
      "tinymce-config": "/tinymce-config/static-2.55357",
      "tinymce-data": "/tinymce-data/static-1.41442",
      "transmute": "/transmute/static-2.97",
      "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5658",
      "urlinator": "/urlinator/static-1.4971",
      "usage-tracker-core": "/usage-tracker-core/static-1.7627",
      "video-embed": "/video-embed/static-1.36884",
      "web-interactives-components": "/web-interactives-components/static-1.14454",
      "web-interactives-data": "/web-interactives-data/static-1.14455",
      "wootric-nps": "/wootric-nps/static-1.7288",
      "ai-components-ui-library": "/ai-components-ui-library/static-1.9979",
      "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.94",
      "asset-actions-lib": "/asset-actions-lib/static-1.47222",
      "campaigns-lib": "/campaigns-lib/static-1.27875",
      "content-assistance-lib": "/content-assistance-lib/static-1.8392",
      "content-label-lib": "/content-label-lib/static-1.7268",
      "content-management-actions-lib": "/content-management-actions-lib/static-1.28652",
      "content-management-data-lib": "/content-management-data-lib/static-1.6196",
      "content-management-restrictions-lib": "/content-management-restrictions-lib/static-1.5998",
      "copilot-toolkit": "/copilot-toolkit/static-1.12107",
      "cssUtils": "/cssUtils/static-1.1078",
      "cta-picker": "/cta-picker/static-1.37189",
      "customer-data-objects": "/customer-data-objects/static-1.8151",
      "customer-data-properties": "/customer-data-properties/static-1.52983",
      "customer-data-property-utils": "/customer-data-property-utils/static-1.8503",
      "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13622",
      "data-token-picker": "/data-token-picker/static-1.17096",
      "error-messaging-js": "/error-messaging-js/static-1.5592",
      "file-manager-components": "/file-manager-components/static-1.24799",
      "FileManagerCore": "/FileManagerCore/static-1.40298",
      "FormsCommonComponents": "/FormsCommonComponents/static-1.86798",
      "foundations-theming": "/foundations-theming/static-1.4943",
      "growth-onboarding-beacon": "/growth-onboarding-beacon/static-1.6043",
      "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3516",
      "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2974",
      "growth-payments-core": "/growth-payments-core/static-1.26463",
      "hs-lodash": "/hs-lodash/static-4.45",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
      "immer": "/immer/static-1.105",
      "immutable": "/immutable/static-2.88",
      "layout-data-lib": "/layout-data-lib/static-1.10489",
      "media-bridge-lib": "/media-bridge-lib/static-1.19609",
      "object-builder-ui-client": "/object-builder-ui-client/static-1.49995",
      "onboarding-tours": "/onboarding-tours/static-1.17366",
      "onboarding-tours-client": "/onboarding-tours-client/static-1.5581",
      "page-lib": "/page-lib/static-1.23637",
      "payment-link-components": "/payment-link-components/static-1.24402",
      "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5559",
      "PortalIdParser": "/PortalIdParser/static-2.404",
      "products-ui-components": "/products-ui-components/static-1.41368",
      "quartz-routing": "/quartz-routing/static-1.1064",
      "quick-fetch": "/quick-fetch/static-1.4222",
      "raven": "/raven/static-3.5925",
      "react": "/react/static-7.202",
      "react-colorpicker": "/react-colorpicker/static-2.10666",
      "react-dnd-compat": "/react-dnd-compat/static-1.5066",
      "react-rhumb": "/react-rhumb/static-1.17191",
      "redux": "/redux/static-4.81",
      "redux-request-state": "/redux-request-state/static-1.11095",
      "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8563",
      "rich-text-lib": "/rich-text-lib/static-1.20519",
      "rpc-client-utils": "/rpc-client-utils/static-1.5128",
      "SharedLegalStrings": "/SharedLegalStrings/static-1.2184",
      "simple-menus-lib": "/simple-menus-lib/static-1.17295",
      "smart-content-lib": "/smart-content-lib/static-1.44074",
      "styled-components": "/styled-components/static-2.100",
      "theme-previewer-lib": "/theme-previewer-lib/static-1.54102",
      "tinymce-copilot": "/tinymce-copilot/static-1.17425",
      "tinymce-plugins": "/tinymce-plugins/static-1.58471",
      "tinymce-themes": "/tinymce-themes/static-1.57327",
      "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10319",
      "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11343",
      "ui-addon-i18n": "/ui-addon-i18n/static-1.11601",
      "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9531",
      "ui-addon-opt": "/ui-addon-opt/static-4.8846",
      "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18537",
      "ui-business-units-lib": "/ui-business-units-lib/static-1.9553",
      "ui-gdpr-components": "/ui-gdpr-components/static-1.10652",
      "ui-product-approvals": "/ui-product-approvals/static-1.29632",
      "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1527",
      "ui-shepherd-react": "/ui-shepherd-react/static-3.10732",
      "ui-suspension-banners-lib": "/ui-suspension-banners-lib/static-1.6845",
      "UIComponents": "/UIComponents/static-3.8893",
      "underscore": "/underscore/static-1.8",
      "usage-tracker": "/usage-tracker/static-1.7777",
      "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5463",
      "user-context": "/user-context/static-1.5508",
      "xray-recommendation-lib": "/xray-recommendation-lib/static-1.8432",
      "codemirror": "/codemirror/static-5.106",
      "react-codemirror": "/react-codemirror/static-1.11095",
      "enviro": "/enviro/static-4.455",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
      "raven-hubspot": "/raven-hubspot/static-1.6232",
      "classnames": "/classnames/static-2.10",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "metrics-js": "/metrics-js/static-1.9990",
      "moment": "/moment/static-3.75",
      "react-dom": "/react-dom/static-7.85",
      "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.712",
      "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.23727",
      "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.3810",
      "frontend-preferences-client": "/frontend-preferences-client/static-1.8374",
      "hs-resources": "/hs-resources/static-1.647",
      "magpie-lib": "/magpie-lib/static-1.5893",
      "marketing-platform-lib": "/marketing-platform-lib/static-1.7353",
      "pulse": "/pulse/static-1.1098",
      "quartz-config": "/quartz-config/static-1.1412",
      "quartz-core": "/quartz-core/static-1.6853",
      "advanced-menus-core": "/advanced-menus-core/static-1.15779",
      "advanced-menus-lib": "/advanced-menus-lib/static-1.12541",
      "automation-ui-ubb": "/automation-ui-ubb/static-1.6775",
      "avatar-components": "/avatar-components/static-1.2941",
      "cms-field-types": "/cms-field-types/static-1.5268",
      "content-embed-lib": "/content-embed-lib/static-1.7796",
      "ExportDialog": "/ExportDialog/static-6.10826",
      "forms-utils-lib": "/forms-utils-lib/static-1.13302",
      "foundations-components-legacy": "/foundations-components-legacy/static-1.1735",
      "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14796",
      "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.2283",
      "payments-embed-points-lib": "/payments-embed-points-lib/static-1.13814",
      "products-iframe-lib": "/products-iframe-lib/static-1.8862",
      "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4719",
      "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16901",
      "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.10704",
      "usage-tracker-container": "/usage-tracker-container/static-1.7767",
      "video-data-lib": "/video-data-lib/static-1.36050",
      "videoconference-integration-components": "/videoconference-integration-components/static-1.7498",
      "graphql": "/graphql/static-1.93",
      "access-check-ui-lib": "/access-check-ui-lib/static-1.1847",
      "editor-iframe-lib": "/editor-iframe-lib/static-1.8979",
      "FireAlarmUi": "/FireAlarmUi/static-1.4841",
      "hub-http-janus": "/hub-http-janus/static-1.904",
      "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5335",
      "layout-dnd-components": "/layout-dnd-components/static-1.13189",
      "marketing-email-service-types": "/marketing-email-service-types/static-1.2209",
      "quartz-auth": "/quartz-auth/static-1.1309",
      "smart-content-core": "/smart-content-core/static-1.43421",
      "social-composer-lib": "/social-composer-lib/static-1.60558",
      "structured-content-lib": "/structured-content-lib/static-1.26158",
      "timezone-utils": "/timezone-utils/static-2.5687",
      "ui-addon-video-player": "/ui-addon-video-player/static-1.9079",
      "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11557",
      "ui-tool-access": "/ui-tool-access/static-1.10614",
      "content-icons-ui": "/content-icons-ui/static-1.2439",
      "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7604",
      "customer-agent-audience-seg-components-lib": "/customer-agent-audience-seg-components-lib/static-1.914",
      "customer-agent-knowledge-generator-lib": "/customer-agent-knowledge-generator-lib/static-1.360",
      "customer-agent-short-answers-lib": "/customer-agent-short-answers-lib/static-1.1179",
      "prosemirror": "/prosemirror/static-1.13",
      "breeze-engine-core": "/breeze-engine-core/static-1.1363",
      "breeze-engine-lib": "/breeze-engine-lib/static-1.2085",
      "final-form": "/final-form/static-1.82",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2659",
      "voice-agents-components": "/voice-agents-components/static-1.4035",
      "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
      "react-aria": "/react-aria/static-1.76",
      "audio-components": "/audio-components/static-1.6538",
      "FileManagerImages": "/FileManagerImages/static-1.37950",
      "quartz-i18n": "/quartz-i18n/static-1.1309",
      "video-components": "/video-components/static-1.14394",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4979",
      "floating-ui": "/floating-ui/static-1.67",
      "framer-motion": "/framer-motion/static-1.83",
      "hs-story-utils": "/hs-story-utils/static-1.9879",
      "react-create-root-preference": "/react-create-root-preference/static-1.99",
      "tanstack-table": "/tanstack-table/static-1.65",
      "trellis-assets": "/trellis-assets/static-1.3033",
      "ui-fonts": "/ui-fonts/static-1.1209",
      "HeadJS": "/HeadJS/static-2.817",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3603",
      "msw": "/msw/static-1.102",
      "msw-config": "/msw-config/static-1.26",
      "testing-library": "/testing-library/static-1.163",
      "hs-locale-management": "/hs-locale-management/static-1.391",
      "ts-schema": "/ts-schema/static-1.4385",
      "content-media-capture": "/content-media-capture/static-1.5748",
      "knowledge-content-types": "/knowledge-content-types/static-1.8743",
      "i18n-data": "/i18n-data/static-1.234",
      "moment-timezone": "/moment-timezone/static-5.95",
      "jquery": "/jquery/static-3.6",
      "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9359",
      "react-dnd-ipeui-backend": "/react-dnd-ipeui-backend/static-1.2345",
      "jasmine": "/jasmine/static-4.4763",
      "customer-data-filters-ui": "/customer-data-filters-ui/static-1.41311",
      "marketplace-embed": "/marketplace-embed/static-1.23163",
      "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9984",
      "flux-actions": "/flux-actions/static-1.380",
      "redux-observable": "/redux-observable/static-1.79",
      "ReduxMessenger": "/ReduxMessenger/static-2.10824",
      "rxjs": "/rxjs/static-5.10",
      "react-flip-move": "/react-flip-move/static-1.82",
      "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6193",
      "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5042",
      "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13552",
      "content-media-compositions": "/content-media-compositions/static-2.17559",
      "idb-keyval": "/idb-keyval/static-1.55",
      "immerable": "/immerable/static-1.4598",
      "magpie-types": "/magpie-types/static-1.5353",
      "ai-rendering-library": "/ai-rendering-library/static-1.11363",
      "chatspot-core": "/chatspot-core/static-1.23736",
      "simple-logging-lib": "/simple-logging-lib/static-1.3508",
      "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
      "nudge-client-utils": "/nudge-client-utils/static-1.3382",
      "sassPrefix": "/sassPrefix/static-1.344",
      "salesImages": "/salesImages/static-1.710",
      "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6072",
      "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8219",
      "ui-universal-auth": "/ui-universal-auth/static-1.9684",
      "autolinker": "/autolinker/static-3.11",
      "chirp-fetch": "/chirp-fetch/static-1.2359",
      "foundations-theming-base": "/foundations-theming-base/static-1.3928",
      "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3694",
      "attribution-lib": "/attribution-lib/static-1.42979",
      "crm-message-bus": "/crm-message-bus/static-1.44053",
      "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4434",
      "framework-listing-lib": "/framework-listing-lib/static-2.29764",
      "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1711",
      "reporting-enablement": "/reporting-enablement/static-1.24128",
      "reporting-ui-components": "/reporting-ui-components/static-2.66552",
      "stylex": "/stylex/static-1.46",
      "trellis-components": "/trellis-components/static-1.3052",
      "trellis-theming": "/trellis-theming/static-1.1448",
      "ui-addon-teams": "/ui-addon-teams/static-1.21993",
      "ui-coaching-tips": "/ui-coaching-tips/static-1.29561",
      "hubspotter-http": "/hubspotter-http/static-1.4965",
      "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4141",
      "batch-promise": "/batch-promise/static-1.2002",
      "calling-global-api": "/calling-global-api/static-1.66119",
      "calling-internal-common": "/calling-internal-common/static-1.31780",
      "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67501",
      "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59794",
      "commerce-products-lib": "/commerce-products-lib/static-1.10850",
      "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4103",
      "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4730",
      "crm-links": "/crm-links/static-1.6762",
      "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.10192",
      "external-options-client-types": "/external-options-client-types/static-1.4431",
      "formula-editor": "/formula-editor/static-1.14982",
      "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7350",
      "google-libphonenumber": "/google-libphonenumber/static-1.49",
      "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3768",
      "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4513",
      "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.1092",
      "multi-currency-client-types": "/multi-currency-client-types/static-1.3998",
      "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4272",
      "property-value-citations": "/property-value-citations/static-1.3597",
      "smart-data-capture-core": "/smart-data-capture-core/static-1.435",
      "smart-property-lib": "/smart-property-lib/static-1.8592",
      "tiered-pricing": "/tiered-pricing/static-1.2195",
      "topics-actions-lib": "/topics-actions-lib/static-1.634",
      "trellis-ext-i18n": "/trellis-ext-i18n/static-1.1352",
      "trial-components-library": "/trial-components-library/static-1.14342",
      "zustand": "/zustand/static-1.88",
      "poll-commands": "/poll-commands/static-1.3930",
      "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.848",
      "html-to-image": "/html-to-image/static-1.65",
      "redux-toolkit": "/redux-toolkit/static-1.82",
      "forms-ai-lib": "/forms-ai-lib/static-1.4952",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3426",
      "embedded-academy-lib": "/embedded-academy-lib/static-1.15956",
      "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.7037",
      "seat-types-lib": "/seat-types-lib/static-1.1009",
      "purchase-motions-components": "/purchase-motions-components/static-1.6605",
      "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19524",
      "growth-data-modal": "/growth-data-modal/static-1.6103",
      "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2946",
      "navigation-components": "/navigation-components/static-1.19120",
      "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1433",
      "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8113",
      "commerce-tours-lib": "/commerce-tours-lib/static-1.6829",
      "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5536",
      "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3979",
      "commerce-permissions": "/commerce-permissions/static-1.1240",
      "commerce-subscription-lib": "/commerce-subscription-lib/static-1.38037",
      "commerce-tax-lib": "/commerce-tax-lib/static-1.993",
      "crm_data": "/crm_data/static-4.93159",
      "customer-data-tracking": "/customer-data-tracking/static-1.7328",
      "dispatcher": "/dispatcher/static-1.147",
      "framework-data-table": "/framework-data-table/static-2.12803",
      "price-books-api": "/price-books-api/static-1.2013",
      "price-books-components": "/price-books-components/static-1.2071",
      "property-description-translator": "/property-description-translator/static-1.4274",
      "ramp-editor": "/ramp-editor/static-1.1129",
      "quartz-head": "/quartz-head/static-1.1299",
      "quartz-test": "/quartz-test/static-1.1309",
      "csstype": "/csstype/static-1.50",
      "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.155",
      "web-vitals": "/web-vitals/static-1.19",
      "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.538",
      "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.11283",
      "redux-mock-store": "/redux-mock-store/static-1.8",
      "redux-undo": "/redux-undo/static-1.10",
      "navigation-messaging": "/navigation-messaging/static-1.8447",
      "merchandise-lib": "/merchandise-lib/static-1.283",
      "trellis-ext-dnd": "/trellis-ext-dnd/static-1.508",
      "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18642",
      "seo-tools-lib": "/seo-tools-lib/static-1.6901",
      "diff-match-patch": "/diff-match-patch/static-1.7",
      "browser-eslint": "/browser-eslint/static-2.57",
      "bender-build-tools": "/bender-build-tools/static-1.3553",
      "event-emitter": "/event-emitter/static-1.1417",
      "fdsr-migration-layer": "/fdsr-migration-layer/static-1.469",
      "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4323",
      "reactive-lib": "/reactive-lib/static-1.1179",
      "bend-plugin-pulse": "/bend-plugin-pulse/static-1.601",
      "fast-json-patch": "/fast-json-patch/static-1.74",
      "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.245",
      "general-store": "/general-store/static-6.20",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.601",
      "module-federation": "/module-federation/static-1.37",
      "opentelemetry-fe": "/opentelemetry-fe/static-1.620",
      "quartz-tracking": "/quartz-tracking/static-1.1013",
      "automation-platform-service-types": "/automation-platform-service-types/static-1.2726",
      "automation-ui-core": "/automation-ui-core/static-2.22795",
      "automation-ui-types": "/automation-ui-types/static-1.20859",
      "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.22258",
      "data-studio-ubb": "/data-studio-ubb/static-1.3774",
      "trellis-migration-context": "/trellis-migration-context/static-1.33",
      "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.1732",
      "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.1902",
      "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3967",
      "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.24154",
      "fail-safe": "/fail-safe/static-1.403",
      "highcharts": "/highcharts/static-8.115",
      "one-click-checkout": "/one-click-checkout/static-1.718",
      "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7993",
      "reporting-visualizations": "/reporting-visualizations/static-1.61357",
      "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15410",
      "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2143",
      "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.794",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10863",
      "nested-table": "/nested-table/static-1.688",
      "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.1063",
      "highlight.js": "/highlight.js/static-1.90",
      "markdown-it": "/markdown-it/static-1.6",
      "calling-orchestration-shared-library": "/calling-orchestration-shared-library/static-1.36945",
      "social-insights-client-types": "/social-insights-client-types/static-1.22893",
      "stylex-utils": "/stylex-utils/static-1.170",
      "fix-webm-duration": "/fix-webm-duration/static-1.34",
      "notification-sounds": "/notification-sounds/static-1.4881",
      "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23746",
      "events-data-lib": "/events-data-lib/static-1.702",
      "FormUrlGenerator": "/FormUrlGenerator/static-2.5170",
      "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1461",
      "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14730",
      "segments-client-types": "/segments-client-types/static-1.12089",
      "connections-embed-lib": "/connections-embed-lib/static-1.1710",
      "marketplace-ui-common": "/marketplace-ui-common/static-1.21011",
      "marketplace-ui-install": "/marketplace-ui-install/static-1.997",
      "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.15181",
      "trellis-ecosystem": "/trellis-ecosystem/static-1.7816",
      "js-cookie": "/js-cookie/static-1.18",
      "breeze-onboarding-components": "/breeze-onboarding-components/static-1.1022",
      "data-integrations-breeze": "/data-integrations-breeze/static-1.266",
      "global-styles-ai-lib": "/global-styles-ai-lib/static-1.453",
      "marketplace-embed-ba": "/marketplace-embed-ba/static-1.866",
      "mermaid": "/mermaid/static-1.44",
      "reporting-action-components": "/reporting-action-components/static-1.42342",
      "reporting-data": "/reporting-data/static-1.69283",
      "reporting-snowflake": "/reporting-snowflake/static-1.57899",
      "upgrade-components-lib": "/upgrade-components-lib/static-1.696",
      "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3139",
      "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3458",
      "whisper-core-api": "/whisper-core-api/static-1.7600",
      "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3464",
      "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1480",
      "copilot-messaging": "/copilot-messaging/static-1.2357",
      "report-customization-components": "/report-customization-components/static-1.14171",
      "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1981",
      "customer-data-views-management": "/customer-data-views-management/static-1.26311",
      "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7255",
      "switchboard-lib": "/switchboard-lib/static-1.686",
      "data-quality-ui-library": "/data-quality-ui-library/static-1.14234",
      "reporting-filters": "/reporting-filters/static-1.1254",
      "reporting-insights-lib": "/reporting-insights-lib/static-1.2886",
      "reporting-plugins": "/reporting-plugins/static-1.10951",
      "reporting-reports": "/reporting-reports/static-1.68959",
      "persist-promise": "/persist-promise/static-1.4159",
      "base-ui": "/base-ui/static-1.27",
      "react-day-picker": "/react-day-picker/static-1.14",
      "tanstack-virtual": "/tanstack-virtual/static-1.42",
      "calling-error-reporting": "/calling-error-reporting/static-1.31787",
      "shared-worker-versioning": "/shared-worker-versioning/static-1.11496",
      "calling-usage-tracker": "/calling-usage-tracker/static-1.6989",
      "voice-sms-access-library": "/voice-sms-access-library/static-1.2393",
      "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11247",
      "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6905",
      "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10948",
      "sales-views-client-types": "/sales-views-client-types/static-1.4712",
      "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10378",
      "bark-lib": "/bark-lib/static-1.16987",
      "browser-prettier": "/browser-prettier/static-1.11",
      "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6346",
      "data-agent-kit": "/data-agent-kit/static-1.875",
      "data-agent-test-utils": "/data-agent-test-utils/static-1.419",
      "data-agent-utils": "/data-agent-utils/static-1.888",
      "fsm": "/fsm/static-1.4214",
      "policy-lib": "/policy-lib/static-1.7264",
      "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.11011",
      "hubs-service-types": "/hubs-service-types/static-1.1721",
      "purchase-motions-api": "/purchase-motions-api/static-1.6608",
      "signup-constants": "/signup-constants/static-1.19902",
      "academy-common-lib": "/academy-common-lib/static-1.15417",
      "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8512",
      "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2807",
      "user-context-client": "/user-context-client/static-1.4965",
      "nest": "/nest/static-1.689",
      "commerce-billing-lib": "/commerce-billing-lib/static-1.20476",
      "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.19529",
      "crm_universal": "/crm_universal/static-1.22690",
      "customer-data-email": "/customer-data-email/static-1.18612",
      "customer-data-associations": "/customer-data-associations/static-1.7791",
      "tasks-actions-lib": "/tasks-actions-lib/static-1.394",
      "line-items-api": "/line-items-api/static-1.1296",
      "customer-data-rte": "/customer-data-rte/static-1.33862",
      "cv-backend-services": "/cv-backend-services/static-1.1607",
      "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6497",
      "qrcode-generator": "/qrcode-generator/static-1.80",
      "quotes-client-types": "/quotes-client-types/static-1.39140",
      "dnd-kit": "/dnd-kit/static-1.20",
      "opentelemetry-web": "/opentelemetry-web/static-1.22",
      "immutable-less": "/immutable-less/static-1.5107",
      "automation-ui-routing": "/automation-ui-routing/static-1.22216",
      "sql-reporting-client-types": "/sql-reporting-client-types/static-1.6014",
      "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19543",
      "stripe-embedded-components": "/stripe-embedded-components/static-1.8209",
      "bend-plugin-fail-safe": "/bend-plugin-fail-safe/static-1.354",
      "checkout-sdk": "/checkout-sdk/static-3.24656",
      "payment-method-components": "/payment-method-components/static-1.7300",
      "touchless-buying-components": "/touchless-buying-components/static-1.6524",
      "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3880",
      "edison-service-client-types": "/edison-service-client-types/static-1.849",
      "react-window": "/react-window/static-1.13",
      "ts-utils-lib": "/ts-utils-lib/static-1.605",
      "calling-orchestration-schema": "/calling-orchestration-schema/static-1.37170",
      "integrations-reconnect-lib": "/integrations-reconnect-lib/static-1.683",
      "unified-auth": "/unified-auth/static-1.1198",
      "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8550",
      "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18418",
      "ai-studio-lib": "/ai-studio-lib/static-1.12720",
      "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8409",
      "storybook-react": "/storybook-react/static-1.44",
      "trellis-story-utils": "/trellis-story-utils/static-1.4956",
      "onboarding-journeys-lib": "/onboarding-journeys-lib/static-1.1198",
      "dashboard-lib": "/dashboard-lib/static-1.83251",
      "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.19236",
      "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.9166",
      "reporting-client-types": "/reporting-client-types/static-1.2816",
      "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3863",
      "crm-export-dialog": "/crm-export-dialog/static-1.6731",
      "crm-index-ui-shimmer": "/crm-index-ui-shimmer/static-1.2936",
      "crm-view-components": "/crm-view-components/static-1.1456",
      "merge-modal-lib": "/merge-modal-lib/static-1.12991",
      "campaign-roi-lib": "/campaign-roi-lib/static-1.10754",
      "ui-addon-calendars": "/ui-addon-calendars/static-2.5818",
      "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16629",
      "enrichment-settings-lib": "/enrichment-settings-lib/static-1.202",
      "academy-service-client": "/academy-service-client/static-1.4147",
      "croppie": "/croppie/static-2.10",
      "SafeStorage": "/SafeStorage/static-1.4850",
      "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8072",
      "utility-belt": "/utility-belt/static-1.2992",
      "sequences-lib": "/sequences-lib/static-1.8736",
      "draft-content-plugins": "/draft-content-plugins/static-1.29118",
      "draft-convert": "/draft-convert/static-2.83",
      "draft-extend": "/draft-extend/static-3.87",
      "draft-js": "/draft-js/static-5.89",
      "draft-plugins": "/draft-plugins/static-2.22322",
      "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10994",
      "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4371",
      "stripe-connect-js": "/stripe-connect-js/static-1.82",
      "hub-http-rxjs": "/hub-http-rxjs/static-1.874",
      "normalizr": "/normalizr/static-3.9",
      "ramda": "/ramda/static-1.7",
      "billing-payments-client-types": "/billing-payments-client-types/static-1.4445",
      "company-details-components": "/company-details-components/static-1.6659",
      "emoji-regex": "/emoji-regex/static-1.7",
      "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.1008",
      "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.16422",
      "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3911",
      "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.726",
      "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1879",
      "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.248",
      "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1293",
      "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.453",
      "slack-ui-library": "/slack-ui-library/static-1.10855",
      "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.829",
      "simple-data-table": "/simple-data-table/static-1.3788",
      "property-management-iframe": "/property-management-iframe/static-1.14412",
      "redux-actions": "/redux-actions/static-3.74",
      "EmailSignatureEditor": "/EmailSignatureEditor/static-1.25209",
      "viral-links-lib": "/viral-links-lib/static-1.7536",
      "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8593",
      "apps-service-types": "/apps-service-types/static-1.4096",
      "oauth-service-types": "/oauth-service-types/static-1.4597",
      "company-details-service-types": "/company-details-service-types/static-1.4399",
      "segments-query-core": "/segments-query-core/static-1.1886",
      "pricing-pages-api": "/pricing-pages-api/static-1.16287",
      "property-management-common": "/property-management-common/static-1.6700",
      "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.4304",
      "crm-component-utils": "/crm-component-utils/static-1.40134",
      "crm-actions": "/crm-actions/static-1.6809",
      "crm-cards-sdk": "/crm-cards-sdk/static-1.44951",
      "crm-fe-perf": "/crm-fe-perf/static-1.23352",
      "universal-record-utils-lib": "/universal-record-utils-lib/static-1.2314",
      "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.10418"
    },
    "bundlingPackage": "page-editor-ui",
    "bundlingPackageVersion": "static-1.39570",
    "project": "page-editor-ui",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};